"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAnalyticalDashboardUserUris = exports.getVisualizationUserUris = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
/**
 * @internal
 * TODO consider making this a generic method in api-model-bear that can handle any metadata object and wrapped metadata object
 */
function getVisualizationUserUris(visualization) {
    return uniq_1.default(compact_1.default([
        visualization.visualizationObject.meta.author,
        visualization.visualizationObject.meta.contributor,
    ]));
}
exports.getVisualizationUserUris = getVisualizationUserUris;
/**
 * @internal
 * TODO consider making this a generic method in api-model-bear that can handle any metadata object and wrapped metadata object
 */
function getAnalyticalDashboardUserUris(dashboard) {
    return uniq_1.default(compact_1.default([dashboard.analyticalDashboard.meta.author, dashboard.analyticalDashboard.meta.contributor]));
}
exports.getAnalyticalDashboardUserUris = getAnalyticalDashboardUserUris;
//# sourceMappingURL=metadata.js.map